import PaginaTexto from '@/components/feature/PaginaTexto';
import { termos } from '@/conteudo/termos';

export default function TermosPage() {
  return <PaginaTexto documento={termos} />;
}